const removeSeparators = (value: string) =>
    value
        .replace(/\s/g, "")
        .replace(/\//g, "")
        .replace(/\./g, "")
        .replace(/-/g, "");

export default removeSeparators;
